"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultScreens = void 0;
var constants_1 = require("../constants");
var celo_dance_1 = require("./celo-dance");
var celo_wallet_1 = require("./celo-wallet");
var cew_1 = require("./cew");
var ledger_1 = require("./ledger");
var metamask_1 = require("./metamask");
var private_key_1 = require("./private-key");
var valora_1 = require("./valora");
var wallet_connect_1 = require("./wallet-connect");
exports.defaultScreens = (_a = {},
    _a[constants_1.SupportedProviders.Valora] = valora_1.Valora,
    _a[constants_1.SupportedProviders.MetaMask] = metamask_1.MetaMaskOrInjectedWallet,
    _a[constants_1.SupportedProviders.WalletConnect] = wallet_connect_1.WalletConnect,
    _a[constants_1.SupportedProviders.Ledger] = ledger_1.Ledger,
    _a[constants_1.SupportedProviders.CeloWallet] = celo_wallet_1.CeloWallet,
    _a[constants_1.SupportedProviders.CeloDance] = celo_dance_1.CeloDance,
    _a[constants_1.SupportedProviders.CeloTerminal] = wallet_connect_1.WalletConnect,
    _a[constants_1.SupportedProviders.CeloExtensionWallet] = cew_1.CeloExtensionWallet,
    _a[constants_1.SupportedProviders.Injected] = metamask_1.MetaMaskOrInjectedWallet,
    _a[constants_1.SupportedProviders.PrivateKey] = private_key_1.PrivateKey,
    _a);
//# sourceMappingURL=index.js.map